import { useSelector } from 'react-redux';

import { ThemeProvider, CssBaseline, StyledEngineProvider } from '@mui/material';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { jaJP } from '@mui/x-date-pickers/locales';

// routing
import Routes from './routes';

// defaultTheme
import theme from './themes';

// project imports
import NavigationScroll from './layout/NavigationScroll';
import ToastProvider from './hooks/ToastProvider';
import { LoadingProvider } from './hooks/LoadingProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ja';

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.locale('ja');
dayjs.tz.setDefault('Asia/Tokyo');
//-----------------------|| APP ||-----------------------//

const globalLocaleText = {
    ...jaJP.components.MuiLocalizationProvider.defaultProps.localeText,
};

const App = () => {
    const customization = useSelector((state) => state.ui.customization);
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: false
            }
        }
    });
    return (
        <StyledEngineProvider injectFirst>
            <ToastProvider>
                <QueryClientProvider client={queryClient}>
                    <LoadingProvider>
                        <ThemeProvider theme={theme(customization)}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja" localeText={globalLocaleText}>
                                <CssBaseline />
                                <NavigationScroll>
                                    <Routes />
                                </NavigationScroll>
                            </LocalizationProvider>
                        </ThemeProvider>
                    </LoadingProvider>
                </QueryClientProvider>
            </ToastProvider>
        </StyledEngineProvider>
    );
};

export default App;
